import { formatHours } from "../../utils/timecard";
import ChevronIcon from "../common/ChevronIcon";

/**
 * Mobile "day card" wrapper shared by the Call and Call-back hours sections:
 * a collapsible <details> with a summary (date, optional hospital, hours) and a
 * fields body supplied as children.
 */
export default function DayCard({ day, dateLabel, hospital, totalHours, setDayCardRef, children }) {
  const isEmpty = !(Number.parseFloat(totalHours) > 0);
  return (
    <details
      className={`day-card${isEmpty ? " day-card--empty" : ""}`}
      ref={(element) => setDayCardRef(day, element)}
    >
      <summary>
        <ChevronIcon />
        <div className="day-card-summary-content">
          <span className="day-card-date">{dateLabel}</span>
          {hospital && <span className="day-card-summary-hospital">{hospital}</span>}
        </div>
        <strong className={isEmpty ? "day-card-hours--empty" : undefined}>
          {formatHours(Number.parseFloat(totalHours) || 0)}
        </strong>
      </summary>
      <div className="day-card-fields">
        {children}
      </div>
    </details>
  );
}
